module.exports = require("./../../_gen/starling/animation/Tween");